import { memo } from 'react';

import { WorkspaceAgentAssetListRow } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/cards/WorkspaceAgentAssetListRow';
import { type WorkspaceAgentThumbnail } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/cards/workspaceAgentThumbnailTypes';

export type WorkspaceAgentAssetListRowsProps = {
  'data-testid'?: string;
  onOpen?: (id: string) => void;
  thumbnails: WorkspaceAgentThumbnail[];
};

export const WorkspaceAgentAssetListRows = memo(
  ({ 'data-testid': testId, onOpen, thumbnails }: WorkspaceAgentAssetListRowsProps) => (
    <div className="max-h-52 min-h-0 overflow-y-auto px-1.5 py-1.5" data-testid={testId}>
      <div className="flex flex-col gap-px">
        {thumbnails.map((thumbnail) => (
          <WorkspaceAgentAssetListRow key={thumbnail.id} onOpen={onOpen} thumbnail={thumbnail} />
        ))}
      </div>
    </div>
  ),
);

WorkspaceAgentAssetListRows.displayName = 'WorkspaceAgentAssetListRows';
